<script>
import Config from '@/config';
import {mapGetters} from 'vuex';
import Main from '@/mixins/main';
import Size from '@/mixins/size';
import {pageIsFinish} from '@/libs/util';
import {storeGoods, scoreGoodExchange} from '@/api';
import {Image, Search, Button, Toast, List, PullRefresh} from 'vant';

export default {
  mixins: [
    Main,
    Size
  ],
  components: {
    [List.name]: List,
    [Image.name]: Image,
    [Search.name]: Search,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      keyword: null,

      page: 1,
      goods: [],

      loading: false,
      finished: false,
      refreshing: false
    };
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    score() {
      return this.user ? this.user.score : '--';
    }
  },
  mounted() {
    window.document.title = '速电通-积分商城';

    this.loadMyInfo();
  },
  methods: {
    refresh() {
      this.page = 1;
      this.finished = false;
      this.refreshMyInfo();
      this.loadData();
    },
    loadData() {
      if (this.refreshing) {
        this.goods = [];
        this.refreshing = false;
      }

      this.loading = true;
      storeGoods(this.keyword, this.page, Config.pageSize).then(response => {
        if (response.data.code === Config.successCode) {
          this.goods = this.page === 1 ? response.data.body.data : this.goods.concat(response.data.body.data);
          this.finished = pageIsFinish(response.data.body);
          this.page = response.data.body.page + 1;
        }
      }).finally(() => this.loading = false).catch(() => this.finished = true);
    },
    keywordChange() {
      this.refresh();
    },
    toScoreExchange() {
      this.$router.push({name: 'score'});
    },
    exchange(goodsId) {
      scoreGoodExchange(goodsId).then(response => {
        if (response.data.code === Config.successCode) {
          this.refreshMyInfo();
          Toast.success('兑换成功');
        }
      });
    }
  }
}
</script>

<template>
  <van-pull-refresh v-model="refreshing" @refresh="refresh" :style="{height: (height - 60) + 'px'}" id="store">
    <div class="score-info">
      <div class="label-button">
        <div class="label">可用积分</div>
        <div class="button" @click="toScoreExchange">+增加三方平台积分</div>
      </div>
      <div class="score">{{ score }}</div>
    </div>
    <div class="search">
      <van-search v-model="keyword" @search="keywordChange" @clear="keywordChange" clearable placeholder="请输入商品名称" left-icon="search" shape="round"/>
    </div>
    <van-list v-model="loading" :finished="finished" :finished-text="goods.length === 0 ? '' : '没有更多了'" @load="loadData">
      <div class="item" v-for="(item, index) in goods" :key="index">
        <van-image radius="4" width="83" height="60" lazy-load :src="item.cover"/>
        <div class="info">
          <div class="title">{{ item.title }}</div>
          <div class="note">{{ item.description }}</div>
          <div class="exchange">
            <div class="score">
              <div class="num">{{ item.score }}</div>
              <div class="unit">积分</div>
            </div>
            <van-button round size="small" @click="exchange(item.id)">立即兑换</van-button>
          </div>
        </div>
      </div>
    </van-list>
    <div v-if="goods.length === 0" :style="{height: (height - 239) + 'px'}" class="no-data">
      <div class="content">
        <img src="../../assets/images/no-data.png"/>
      </div>
    </div>
  </van-pull-refresh>
</template>

<style scoped>
#store {
  overflow-y: auto;
  background-color: #F6F9F8;
}

#store .score-info {
  background-color: #009251;
  padding: 12px 0 12px 12px;
}

#store .score-info .label-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#store .score-info .label-button .label {
  color: white;
  font-size: 16px;
  font-weight: 500;
}

#store .score-info .label-button .button {
  color: white;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  background-color: #72a83e;
  border-radius: 20px 0 0 20px;

  display: flex;
  align-items: center;
  justify-content: center;
}

#store .score-info .score {
  color: white;
  font-size: 32px;
  font-weight: bold;
  margin-top: 12px;
}

#store .search {
  padding-bottom: 8px;
}

#store .item {
  display: flex;
  align-items: center;
  padding: 12px;
  margin: 0 8px;
  border-radius: 8px;
  background-color: white;
}

#store .item + .item {
  margin-top: 8px;
}

#store .item:last-child {
  margin-bottom: 12px;
}

#store .item .info {
  flex: 1;
  font-size: 14px;
  margin-left: 12px;
}

#store .item .info .title {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
}

#store .item .info .note {
  color: #999999;
  font-size: 12px;
  margin-top: 2px;
}

#store .item .info .exchange {
  display: flex;
  margin-top: 8px;
  align-items: center;
  justify-content: space-between;
}

#store .item .info .score {
  display: flex;
  align-items: center;
}

#store .item .info .score .num {
  color: #009251;
  font-size: 20px;
  font-weight: bold;
}

#store .item .info .score .unit {
  color: #999999;
  font-size: 12px;
  font-weight: 500;
  margin-left: 4px;
}
</style>